import React from "react";

interface NotFavoriteIconProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
}

export function NotFavoriteIcon({
    color = "black",
    width = 40,
    height = 40,
    ...props
}: NotFavoriteIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            viewBox="0 0 24 24"
            data-name="Layer 1"
            width={width}
            height={height}
            fill={color}
            {...props}
        >
            <path d="m16.5 5a5.98 5.98 0 0 0 -4 1.54 5.98 5.98 0 0 0 -4-1.54c-2.523 0-4.5 2.3-4.5 5.237 0 1.412.6 6.286 8.3 9.72a.5.5 0 0 0 .408 0c7.7-3.434 8.3-8.308 8.3-9.72-.008-2.937-1.985-5.237-4.508-5.237zm-4 13.951c-6.955-3.179-7.5-7.466-7.5-8.714 0-2.376 1.537-4.237 3.5-4.237a5.007 5.007 0 0 1 3.615 1.569.52.52 0 0 0 .77 0 5.007 5.007 0 0 1 3.615-1.569c1.963 0 3.5 1.861 3.5 4.237 0 1.248-.545 5.535-7.5 8.714zm6.5-8.714a.5.5 0 1 1 -1 0c0-1.076-.573-2.237-1.5-2.237a.5.5 0 0 1 0-1c1.564 0 2.5 1.646 2.5 3.237z" />
        </svg>
    );
}
